export default __webpack_public_path__ + "static/media/Werken in een PLG met TGI.4e494498.zip";